module.exports = __webpack_public_path__ + "static/thesource-8b1841b407593fdfb6acb9ec899d2151.png";